import { DailyDepotMetric, DepotId, DepotProfile } from './types';

export const DEPOT_PROFILES: DepotProfile[] = [
  {
    id: 'MGROAD',
    name: 'MGROAD',
    shortName: 'MGR',
    region: 'Bengaluru Core',
    color: '#0f766e',
  },
  {
    id: 'Hyderabad',
    name: 'Hyderabad',
    shortName: 'HYD',
    region: 'South Central',
    color: '#b45309',
  },
  {
    id: 'Mumbai',
    name: 'Mumbai',
    shortName: 'MUM',
    region: 'West Coast',
    color: '#426b1f',
  },
  {
    id: 'Chennai',
    name: 'Chennai',
    shortName: 'CHN',
    region: 'South East',
    color: '#be123c',
  },
];

export const ALL_DEPOT_IDS: DepotId[] = DEPOT_PROFILES.map((depot) => depot.id);

const DAYS = [
  '2026-04-07',
  '2026-04-08',
  '2026-04-09',
  '2026-04-10',
  '2026-04-11',
  '2026-04-12',
  '2026-04-13',
];

interface DepotSeriesSeed {
  depotId: DepotId;
  touchPoints: number[];
  tonnageKg: number[];
  volume: number[];
  trips: number[];
  vehiclesUsed: number[];
  timePerTripHours: number[];
  slotBreaches: number[];
}

const VEHICLES_AVAILABLE = 30;
const AVG_VEHICLE_CAPACITY_KG = 2000;

const SERIES_SEEDS: DepotSeriesSeed[] = [
  {
    depotId: 'MGROAD',
    touchPoints: [612, 628, 651, 672, 704, 726, 742],
    tonnageKg: [21400, 22100, 22950, 23600, 24200, 24950, 25500],
    volume: [119, 122, 127, 130, 134, 137, 141],
    trips: [25, 25, 26, 27, 28, 29, 30],
    vehiclesUsed: [14, 14, 14, 15, 15, 15, 15],
    timePerTripHours: [8.4, 8.2, 8.1, 7.9, 7.8, 7.7, 7.6],
    slotBreaches: [5, 5, 4, 4, 4, 3, 3],
  },
  {
    depotId: 'Hyderabad',
    touchPoints: [548, 566, 594, 621, 636, 658, 681],
    tonnageKg: [22600, 23200, 24100, 25250, 25900, 26600, 27400],
    volume: [126, 129, 134, 139, 142, 147, 151],
    trips: [22, 23, 24, 25, 25, 26, 27],
    vehiclesUsed: [14, 14, 15, 15, 15, 16, 16],
    timePerTripHours: [8.1, 8.0, 8.0, 7.8, 7.9, 7.7, 7.6],
    slotBreaches: [4, 4, 3, 4, 3, 3, 2],
  },
  {
    depotId: 'Mumbai',
    touchPoints: [704, 728, 742, 756, 773, 786, 799],
    tonnageKg: [30750, 31800, 32600, 33350, 34200, 35100, 35900],
    volume: [166, 171, 174, 178, 182, 187, 190],
    trips: [29, 30, 30, 31, 31, 32, 32],
    vehiclesUsed: [20, 20, 20, 21, 21, 21, 21],
    timePerTripHours: [8.6, 8.5, 8.3, 8.4, 8.2, 8.1, 8.0],
    slotBreaches: [7, 6, 6, 5, 5, 4, 4],
  },
  {
    depotId: 'Chennai',
    touchPoints: [428, 446, 462, 487, 512, 536, 558],
    tonnageKg: [20100, 20750, 21400, 22300, 23150, 23900, 24700],
    volume: [108, 111, 115, 119, 123, 127, 132],
    trips: [18, 18, 19, 20, 21, 22, 23],
    vehiclesUsed: [13, 13, 13, 13, 14, 14, 14],
    timePerTripHours: [8.3, 8.2, 8.1, 8.2, 8.0, 7.9, 7.8],
    slotBreaches: [5, 5, 5, 4, 4, 4, 3],
  },
];

export const CONTROL_TOWER_DAILY_METRICS: DailyDepotMetric[] = SERIES_SEEDS.flatMap((seed) =>
  DAYS.map((date, index) => ({
    depotId: seed.depotId,
    date,
    touchPoints: seed.touchPoints[index],
    tonnageKg: seed.tonnageKg[index],
    volume: seed.volume[index],
    vehiclesAvailable: VEHICLES_AVAILABLE,
    avgVehicleCapacityKg: AVG_VEHICLE_CAPACITY_KG,
    totalTrips: seed.trips[index],
    vehiclesUsed: seed.vehiclesUsed[index],
    timePerTripHours: seed.timePerTripHours[index],
    slotBreaches: seed.slotBreaches[index],
  }))
);
